/*
 * component.selectfx
 * http://github.com/typesettin/component.selectfx
 *
 * Copyright (c) 2014 Typesettin. All rights reserved.
 */

'use strict';

module.exports = require('./lib/component.selectfx');



//////////////////
// WEBPACK FOOTER
// ./~/periodicjs.component.selectfx/index.js
// module id = ./node_modules/periodicjs.component.selectfx/index.js
// module chunks = 5